import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import {
	AssetBlok,
	multiAssetToSingleAsset,
	sizes,
} from "@/components/bloks/Asset";
import { LinkWrapper } from "@/components/ui/LinkWrapper";
import type { BlokHero1, StoryblokMultiasset } from "@/storyblok";
import styles from "./Hero1.module.css";

export interface Hero1Props
	extends Pick<BlokHero1, "mainTitle" | "secondaryTitle">,
		ComponentProps<"section"> {
	href?: string;
	mainSource?: StoryblokMultiasset;
	secondarySource?: StoryblokMultiasset;
	lightMode?: boolean;
}

export const Hero1 = ({
	href,
	mainTitle,
	secondaryTitle,
	mainSource,
	secondarySource,
	lightMode,
	className,
	...rest
}: Hero1Props) => {
	return (
		<LinkWrapper href={href}>
			<section className={clsx(styles.root, className)} {...rest}>
				<div className={styles.text}>
					<div className={styles.sentinel} />
					<h1 className={styles.title} data-light={lightMode}>
						<span>{mainTitle}</span>
						<span>{secondaryTitle}</span>
					</h1>
				</div>
				<div className={clsx(styles.asset, styles.mainAsset)}>
					{mainSource?.length && (
						<AssetBlok
							source={multiAssetToSingleAsset(mainSource!)}
							muted
							autoPlay
							loop
							priority
							quality={90}
							sizes={sizes(90, 50)}
						/>
					)}
				</div>

				<div className={clsx(styles.asset, styles.secondaryAsset)}>
					<div className={clsx(styles.secondaryAssetWrap)}>
						{secondarySource?.length && (
							<AssetBlok
								source={multiAssetToSingleAsset(secondarySource!)}
								muted
								autoPlay
								loop
								fetchPriority="high"
								quality={90}
								sizes={sizes(50, 25)}
							/>
						)}
					</div>
				</div>
			</section>
		</LinkWrapper>
	);
};
